import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { ExecuteWorkflowActionStateRequest } from '../../../../../../core/projects.actions';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';

@Component({
    selector: 'app-add-reason-or-signature',
    templateUrl: './add-reason-or-signature.component.html',
    styleUrls: ['./add-reason-or-signature.component.scss'],
    standalone: false
})
export class AddReasonOrSignatureComponent implements OnInit, OnDestroy {
  heading = '';
  action: any;
  id: any;
  projectId: any;
  note = '';

  form = new FormGroup<any>({});
  formFields: any[] = [];

  private readonly onDestroy = new Subject<void>();

  constructor(
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<AddReasonOrSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.action = data.action;
      this.id = data.id;
      this.projectId = data?.projectId;
      const entity = data?.entity;
      if (data?.action?.state === 'change-order-request-unapprove'
        && entity?.linked_change_order_no
        && ['draft', 'rejected'].includes(entity?.linked_change_order_status)) {
        this.note = `This request is part of draft change order ${entity.linked_change_order_no}. Unapproving will remove it from that change order.`;
      }

      // ✅ Ensure formFields is always a new sorted array
      const formInputs = data?.action?.options?.formInputs ?? [];
      this.formFields = [...formInputs].sort((a, b) => {
        if (a.type === 'signature') {
          return 1;
        }
        if (b.type === 'signature') {
          return -1;
        }
        return 0;
      });

    }
  }

  ngOnInit() {
    // ✅ Set heading based on action state
    const state = this.action?.state ?? '';

    if (
      state === 'change-order-request-approve' ||
      state === 'change-order-request-submit' ||
      state === 'change-order-approve' ||
      state === 'change-order-submit'
    ) {
      this.heading = 'Sign';
    } else if (
      state === 'change-order-request-withdraw' ||
      state === 'change-order-withdraw'
    ) {
      this.heading = 'Reason for withdraw';
    } else if (
      state === 'change-order-request-reject' ||
      state === 'change-order-reject'
    ) {
      this.heading = 'Return to submitter';
    } else if (state === 'change-order-request-unapprove') {
      this.heading = 'Reason for unapprove';
    }

    // ✅ Build form controls dynamically
    this.formFields.forEach(field => {
      this.form.addControl(
        field.name,
        new FormControl({ value: null, disabled: false }),
      );
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  clear(): void {
    this.form.reset();
  }

  done(): void {
    const formValues = this.form.getRawValue();

    // Unapproving requires a reason
    if (this.action?.state === 'change-order-request-unapprove'
      && (!formValues?.comments || !String(formValues.comments).trim())) {
      this.form.controls['comments']?.setErrors({ required: true });
      this.form.controls['comments']?.markAsTouched();
      return;
    }

    const { wf, ex, state } = this.action;
    const qp = { wf, ex, state, include: '' };

    const payload = {
      projectId: this.projectId,
      qp,
      input: {
        formValues,
        id: this.id,
      },
    };

    const tempPayload = {
      type: state?.includes('change-order-request') ? 'CIWR' : 'COR',
      payload,
    };

    this.close();
    this.store.dispatch(
      ExecuteWorkflowActionStateRequest({ payload: tempPayload }),
    );
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
